<template>
  <v-app>
    <v-main :class="!IsLoggedIn?'loginbg':''">
      <core-toolbar  v-if="IsLoggedIn"/>
      <core-drawer v-if="IsLoggedIn"/>
      <core-view :class="windowClass"/>
      <template v-if="IsLoggedIn">
        <core-info-drawer/>
        <core-footer/>
      </template>
      <template v-if="actionAlert.show">
      <div class="va-snackbar animate__animated animate__fadeInRight" :class="'va-snackbar-'+actionAlert.type">
      <v-progress-circular indeterminate size="20" v-if="actionAlert.icon=='progress'"></v-progress-circular>
      <v-icon v-else color="white">mdi-{{actionAlert.icon}}</v-icon>
       <span class="mt-3 ml-2">{{actionAlert.text}}</span>
    </div>
    </template>
    
       <v-snackbar
      v-model="showAlert"
      :color="alertColor"
      :timeout="2000"
       :top="'top'"
     >
      {{alertText }}
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
        
    </v-main>

    
  </v-app>
</template>

<script>
import {
  mapMutations
} from 'vuex'

export default {
  name: 'App',
  
  data: () => ({
    showAlert2: true
  }),
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  computed:{
      overlay() {
         return this.$store.state.overlay
      },
      actionAlert() {
        return this.$store.state.action_alert
      },
      showAlert: {
        get () {
          return this.$store.state.show_alert
          },
          set (val) {
            this.setAlert(val)
          }
      },
      alertText() {
        return this.$store.state.alert_text
      },
      alertColor(){
          return this.$store.state.alert_color
      },
      windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      IsLoggedIn(){
         return this.$store.state.is_logged
      }
  },
  methods: {
    ...mapMutations(['setDrawer', 'setResponsive', 'setAlert']),
    
      onResponsiveInverted() {
          if (window.innerWidth < 991) {
           this.setResponsive(true)
          } else {
            this.setDrawer(true)
            this.setResponsive(false)
          }
    },
  }

};
</script>
<style>
@import '~vue-context/dist/css/vue-context.css';
/* .v-text-field--filled.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--filled.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--filled.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--full-width.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--single-line > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot, .v-text-field--outlined.v-input--dense.v-text-field--outlined.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: 36px !important;
} */
 .v-application {
  /* font-family: "Open Sans", sans-serif !important; */
  font-family: "Open Sans", sans-serif !important;
 }
 #hero {
  height: 100%;
  background: url('/img/hero3.jpg') no-repeat left center;
  background-size: cover;
  font-family: "Open Sans", sans-serif;
  font-optical-sizing: auto;
 }
 .loginbg .v-main, .loginbg #core-view{
  height: 100%;
 
 }
.v-input--dense .v-label {
   font-size: .91em !important;
} 
  .v-select__slot, .v-text-field__slot {
      font-size: .91em !important;
    }   
    #va-drawer.zera-nav {
  background-color: none !important;
  background: url('/img/opa.png') repeat center;
}
  #va-drawer, #va-toolbar {
    /* text-transform: uppercase !important; */
  }
   #va-drawer .v-list-item-group .v-list-item--active {
     /* transition: all 0.5s ease; */
    background: #fff  !important; 
    color:#41586E; 
   }
  #va-drawer .v-list-item--active:hover::before,  #va-drawer .v-list-item--active::before {
     opacity: 0 !important; 
   }
  
  .va-not-reponsive {
    padding-left: 255px;
  }
  .va-table {
    width: 100%;
    text-align:  left;
  
  }
  .va-table-border-bot tr:hover {
    background:#f7f7f7;
  }
  .va-table th {
      background:#f7f7f7;
      padding: 2px;
  }
  .va-table-border-bot td {
    padding: 2px;
    border-bottom: 1px solid #ddd;
  }
  .va-select {
    padding: 2px;
    text-align: center;
    border-bottom: 1px solid #ddd;
  }
  @media print {
     .no-print {
     display: none !important;
  }
  
   .va-table td,  .va-table th {
    font-size: 1em !important;
    padding: 1px !important;
    color: #313131 !important;
  }

}
  .va-underline {
    border-bottom: 1px solid #F96332;
  }

  .v-btn__content {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .va-right input{
    text-align: right;
  }

/* Drawer */
/* #va-drawer .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
#va-drawer .v-expansion-panels .v-expansion-panel {
  background: none !important;
  border-radius: 0 !important;
  -webkit-box-shadow:none !important; 
   box-shadow: none !important; 
}
#va-drawer .v-expansion-panel::before {
  -webkit-box-shadow:none !important; 
   box-shadow: none !important;

} */
#va-info-drawer {
  z-index: 999;
}
.va-tab {
  display: block;
  text-align: left;
  width: 100%;
}
  .loginbg {
    /* background:#f1f1f1; */
     /* background-image: url('assets/bg.png');
     background-size: 100% 100%; */
  }
  #loginbtn{
    background: rgb(241,241,241);
background: radial-gradient(circle, rgba(241,241,241,1) 0%, rgba(221,221,221,1) 100%);
    color: #3F96B9 !important;
  }

  .sm-font {
    font-size:  .6em !important;
  }
  .md-font {
     font-size:  .8em !important;
  }
  .def-font {
     font-size:  .9em !important;
  }
    .lg-font {
     font-size:  1.2em !important;
  }
  .color-light {
    color: #b5b5b5;
  } 
 #roomprop .v-expansion-panel-content__wrap {
   padding: 0 !important;
  }

.border_bot {
  border-bottom: 1px solid #eee;
}

  .theme--light.v-input--is-disabled input {
    color: #000 !important;
  }
  .light_text {
    color: #ddd;
  }
  .shadow-text {
     text-shadow: 1px 1px #555;
  }
  .print_table {
    width: 100%;
    font-size: .8em;
    text-align: left;
  }
   .print_table  th {
     font-weight: normal;
   }
    .print_table  th,  .print_table  td {
      padding: 2px;
      border-bottom: 1px solid #c5c5c5;
    }
    .text-secondary {
  color: #19365A;
}
.text-success {
  color: #68BE9F;
}
.text-error {
  color: #f55a4e;
}
.text-primary {
  color: #2d90d3;
}
.text-warning {
  color: #ffa21a;
}
.text-info {
  color: #00d3ee;
}
.text-white {
  color: #fff;
}
.text-accent {
  color: #82B1FF;
}

.bg-success {
  background-color: #5cb860;
}
.bg-error {
  background-color: #f55a4e;
}
.bg-primary {
  background-color: #68BE9F;
}
.bg-warning {
  background-color: #ffa21a;
}
.bg-warning-light {
  background-color: #fae7c8;
}
.bg-info {
  background-color: #00d3ee;
}
.bg-white {
  background-color: #fff;
}
.bg-accent {
  background-color: #82B1FF;
}
.bg-cancelled {
  background-color: #757575;
}
.bg-indigo {
  background-color: #9B70FA;
}
.text-indigo {
  color: #9B70FA;
}
.text-cancelled {
    opacity: .6;
}
.text-gray {
  color: #353535;
}
/* dropzone */
#dropZone:hover {
  border: 2px dashed #555;
  color: #555;
  cursor: pointer;
  background: #f0f0f0;
}
.imgview, ._link {
  cursor: pointer;
}
#dropZone {
  transition: all 0.2s ease;
  background: #f5f5f5;
      width: 100%;
      height: 100px;
      border: 2px dashed #ccc;
      border-radius: 10px;
      text-align: center;
      line-height: 100px;
      color: #999;
    }
    #dropZone.dragover {
      border-color: #000;
      color: #000;
    }
.preview-container {
  text-align: center;
    background: #f5f5f5;
    max-height: 174px;
    border-radius: 10px;
    margin-top: 5px;
    padding: 6px;
    overflow: scroll;
}
.image-preview {
   width: 120px;
   display: block;
   float: left;
   margin: 4px;
  
}
.image-preview  img {
  transition: all 0.2s ease;
  max-width: 120px;
    border: 2px dashed #cdcdcd;
    z-index: 1;
    max-height: 150px;
    margin-top: -12px;
}
.image-preview  img:hover {
  border: 2px dashed #555;
}
.preview-remove {
  float: left;
  z-index: 2;
 margin-left: -10px;
}
.va-snackbar {
    padding: 7px 12px;
    position: fixed;
    bottom:65px;
    right: 7px;
    font-size: .88em;
    border-radius: 8px;
    z-index: 9999;
    color: #f1f1f1;
    min-width: 200px;
}
.va-snackbar-info {
  background-color: #25313E;
}
.va-snackbar-error {
  background-color: #f55a4e;
}
.va-snackbar-warning {
  background-color: #ffa21a;
}
.va-snackbar-success {
  background-color: #5cb860;
}
.va-input {
  border: 1px solid #9c9c9c;
  width: 100%;
  padding: 4px;
}
.prop-item .va-input {
  text-align: center;
}
.prop-item td, .prop-item th {
  border-left: 1px solid #efefef;
  padding: 7px;
  text-align: center;
  border-bottom: 1px solid #efefef;
}
.prop-item th {
  background: #f0f0f0;
}
.prop-item .prop-list {
  background: #fcfcfc;
  padding: 2px;
  margin-bottom: 1px;
}
.va_hover:hover {
  cursor: pointer;
}
.va-drop-list {
  padding: 2x;
  width: 100%;
  line-height: 100%;
  color: #19365A;
}
.va-align-top td, .va-align-top th {
  vertical-align: top;
}
.va-nav-submenu-con {
  background: #00d3ee !important;
}
.va-nav-submenu .v-list-item__title {
   font-weight: normal !important;
}
.input-center .v-text-field__slot input {
  text-align: center !important;
}
input._qty {
  width: 80px;
  text-align: center;
  padding: 2px;
  border: 1px solid #25313E;
}
</style>